import { useRef } from 'react'

import type { ReactRefObject } from '../utils/react'

/**
 * Creates a reference object
 *
 * @param value - Ref value
 * @param isEqual - Function to compare values
 */
export function useVariableRef<TValue = unknown>(
  value: TValue,
  isEqual: (value1: TValue, value2: TValue) => boolean = Object.is
): ReactRefObject<TValue> {
  const propsRef = useRef<TValue>(value)

  if (!isEqual(propsRef.current, value)) {
    propsRef.current = value
  }

  return propsRef
}
